import type { FormDefinition } from '@onkelsepp/contracts';

const contentTypes = new Set(['heading', 'richtext', 'link', 'divider', 'spacer', 'info']);

export function submissionValues(definition: FormDefinition, data: FormData): Record<string, unknown> {
  const values: Record<string, unknown> = {};
  for (const element of definition.elements) {
    if (contentTypes.has(element.type) || (element.type === 'text' && 'content' in element)) continue;
    if (element.type === 'file') values[element.id] = data.getAll(element.id).filter((entry): entry is File => entry instanceof File && entry.size > 0).map((file) => file.name);
    else if (element.type === 'checkbox' || element.type === 'multiSelect') values[element.id] = data.getAll(element.id).map(String);
    else if (element.type === 'consent') values[element.id] = data.get(element.id) === 'on';
    else if (element.type === 'number') values[element.id] = data.get(element.id) === '' ? null : Number(data.get(element.id));
    else values[element.id] = data.get(element.id);
  }
  return values;
}
